import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setOpenLoginFlow, setOpenSignupFlow } from "../../redux/login";
import { toast } from "react-toastify";
import { ReactComponent as GoBackIcon } from "../../assets/svg/arrow_back_icon.svg";
import { verifyEmailOtp, resendEmailOtp } from "../../services/LoginUser";
const VerifyOtp = ({isOtpPage, setIsOtpPage}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [minutes, setMinutes] = useState(10);
  const [seconds, setSeconds] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(false);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      } else {
        setIsResendDisabled(false);
        setIsVerifyDisabled(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds, minutes]);

  const handleChange = (newValue) => {
    setOtp(newValue);
  };

  const handleResendOtp = async () => {
    const email = localStorage.getItem("userEmail");
    const isOtpSent = await resendEmailOtp(email);
  
    if (isOtpSent) {
      toast.success("OTP Resent Successfully", { autoClose: 2500 });
      setMinutes(10);
      setSeconds(0);
      setIsResendDisabled(true);
      setIsVerifyDisabled(false);
    } else {
      toast.error("Failed to resend OTP. Please try again.");
    }
  };
  

  const handleSubmit = async () => {
    if (!otp || otp.length < 6) {
      toast.error("Please Enter OTP", { autoClose: 2500 });
      return;
    }
    const email = localStorage.getItem("userEmail");
    const isVerified = await verifyEmailOtp(otp, email);
    if (isVerified) {
      toast.success("OTP Verified Successfully. Now you can Sign In", {
        autoClose: 2500,
        className: "toast-message",
        position: toast.POSITION.TOP_RIGHT,
      });
      dispatch(setOpenLoginFlow(false));
      dispatch(setOpenSignupFlow(false));
    }
  };

  return (
    <>
      <Box
        component="div"
        className="back-btn"
        sx={{ width: "100%", textAlign: "left", padding: "16px 8px" }}
      >
        <Button
          sx={{
            border: "none !important",
            justifyContent: "left !important",
            height: "30px",
            backgroundColor: "none",
            width: "30px",
            filter:
              "invert(48%) sepia(0%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)",
          }}
          variant="xsSize"
          onClick={() =>setIsOtpPage(false)}
        >
          <GoBackIcon />
        </Button>
      </Box>
      <Box className="signup-form">
        <Typography variant="lSize" className="font-w-500 line-h-extended-1">
          {t("EmailVerification.AccountValidation")}
        </Typography>
        <Box component="div">
          <Typography
            sx={{ margin: "18px 0" }}
            variant="sSize"
            className="line-height-extended-2 font-weight-500"
          >
            {t("EmailVerification.EmailValidation")}
          </Typography>
          <Typography
            variant="xxsSize"
            paragraph
            className="line-h-extended font-weight-500"
          >
            {t("EmailVerification.ThankYouForSigningUpText")}
          </Typography>
        </Box>

        <Box sx={{ margin: "36px 0" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{ margin: "9px 0" }}
              variant="sSize"
              className="line-height-extended-2 font-weight-500"
            >
              {t("EmailVerification.Otp")}
            </Typography>
            <Box>
              <Box component="span">
                {minutes < 10 ? ` 0${minutes}` : minutes}:
                {seconds < 10 ? ` 0${seconds}` : seconds}
              </Box>
            </Box>
          </Box>

          <MuiOtpInput
            length={6}
            value={otp}
            onChange={handleChange}
            className="otp-verify"
          />
        </Box>
        <Box component="div" className="btn-container resend-otp">
          <Button
              sx={{
                bgcolor: isVerifyDisabled ? "#ccc" : "#111111",
                color: "white",
                padding: "8px 50px",
                borderRadius: "20px",
                border: "none",
                cursor: isVerifyDisabled ? "not-allowed" : "pointer",
                "&:hover": {
                  bgcolor: isVerifyDisabled ? "#ccc" : "#111111",
                },
              }}
              variant="outlined"
              type="submit"
              className="font-w-400 signInBtn"
              disabled={isVerifyDisabled}
              onClick={handleSubmit}
          >
            {"Verify"}
          </Button>

          <Button
            sx={{
              marginTop: "16px",
              bgcolor: isResendDisabled ? "#ccc" : "#111111",
              color: "white",
              padding: "8px 50px",
              borderRadius: "20px",
              border: "none",
              cursor: isResendDisabled ? "not-allowed" : "pointer",
              "&:hover": {
                  bgcolor: isResendDisabled ? "#ccc" : "#111111",
              },
            }}
            variant="outlined"
            disabled={isResendDisabled}
            onClick={handleResendOtp}
          >
            Resend OTP
          </Button>
          {/* <Link to="/">
            <Typography
              variant="xxsSize"
              paragraph
              color="#333333"
              className="font-w-400 account-text"
            >
              {t("EmailVerification.Go_Back")}
            </Typography>
          </Link> */}
        </Box>
      </Box>
    </>
  );
};
export default VerifyOtp;
